"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.17.0", "build_date": "2026-05-26T09:50:08.424Z", "build_branch": "development", "build_commit": "bea696417f78a4cf5281265ab63c1ec077013f12" };
//# sourceMappingURL=build_data.js.map